import React, { useState, useEffect } from "react";
import CheckItem from "../components/CheckItem";
import {
  AllCheckerCheckbox,
  Checkbox,
  CheckboxGroup,
} from "@createnl/grouped-checkboxes";

export default function TableLogComponents({
  columns,
  dataSource,
  functionStyleTableRow,
  rowSelection
}) {
  const [checkboxArray, setCheckboxArray] = useState([]);
  const [checkboxAllHeader, setCheckboxAllHeader] = useState(false);
  const [dataSelectAll, setDataSelectAll] = useState([]);
  const dataSource_Length = dataSource.length

  function handleCheckAll() {
    setCheckboxAllHeader(!checkboxAllHeader)
  }

  function selectCheckbox(callBack, dataSource, index) {
    let dataCheckboxAll = checkboxArray;
    dataCheckboxAll.sort(compareFirst);
    if (callBack === true) {
      dataCheckboxAll.push({
        ...dataSource,
        indexDataCheckboxAll: index,
      });
    } else {
      var indexRemoveData = dataCheckboxAll.findIndex(
        (std) => std.indexDataCheckboxAll === index
      );
      dataCheckboxAll.splice(indexRemoveData, 1);
    }

    if(dataCheckboxAll.length === dataSource_Length){
      setCheckboxAllHeader(true)
    } else {
      setCheckboxAllHeader(false)
    }

    dataCheckboxAll.sort(compareFirst);
    setCheckboxArray(dataCheckboxAll);
    rowSelection.onChange(dataCheckboxAll);
  }

  function returnClass(index_columns, allIndex) {
    if (index_columns === 0) return "td-first-table";
    else if (index_columns === allIndex.length - 1) return "td-last-table";
    else return null;
  }

  function compareFirst(a, b) {
    if (a.indexDataCheckboxAll > b.indexDataCheckboxAll) {
      return 1;
    }
    if (a.indexDataCheckboxAll < b.indexDataCheckboxAll) {
      return -1;
    }
    return 0;
  }

  function cutDataToReturn(dataAll) {
    let dataReturnToComponents = []

    dataAll.map( dataReturn => {
      let data_last_return = {}
      for (const [key, value] of Object.entries(dataReturn)) {
        if(key !== "indexDataCheckboxAll"){
          data_last_return[key] = value
        }
      }
      dataReturnToComponents.push(data_last_return)
    })

    return dataReturnToComponents
  }

  const changAll = (e) => {
    if(e.target.checked === true){
      let dataAll = []
      dataSource.map( (dataPushAll , index) => {
        dataAll.push({
          ...dataPushAll,
          indexDataCheckboxAll: index,
        })
      } )
    let dataReturnToComponents = cutDataToReturn(dataAll)

      // let dataReturnToComponents = []
      // dataAll.map( dataReturn => {
      //   let data_last_return = {}
      //   for (const [key, value] of Object.entries(dataReturn)) {
      //     if(key !== "indexDataCheckboxAll"){
      //       data_last_return[key] = value
      //     }
      //   }
      //   dataReturnToComponents.push(data_last_return)
      // })

      setDataSelectAll(dataAll)
      rowSelection.onChange(dataReturnToComponents)
    }else {
      setDataSelectAll([])
      rowSelection.onChange([])
    }
  };

  const changCheckbox = (e, data, index) => {
    const dataInFC = [...dataSelectAll];
    if (e.target.checked === true) {
      dataInFC.push({
        ...data,
        indexDataCheckboxAll: index,
      });
      dataInFC.sort(compareFirst);
    } else {
      const index_data = dataInFC.findIndex(
        (std) => std.indexDataCheckboxAll === index
      );
      dataInFC.splice(index_data, 1);
      dataInFC.sort(compareFirst);
    }

    let dataReturnToComponents = cutDataToReturn(dataInFC)

    // let dataReturnToComponents = []
    // dataInFC.map( dataReturn => {
    //   let data_last_return = {}
    //   for (const [key, value] of Object.entries(dataReturn)) {
    //     if(key !== "indexDataCheckboxAll"){
    //       data_last_return[key] = value
    //     }
    //   }
    //   dataReturnToComponents.push(data_last_return)
    // })

    setDataSelectAll(dataInFC);
    rowSelection.onChange(dataReturnToComponents)
  };

  return (
    <div className="div-table-components-by-nile">
      <CheckboxGroup>
      <table className="table-log-all-components" style={{ overflowX: "auto" }}>
        <tbody>
          <tr>
            {rowSelection !== undefined && rowSelection.type === "checkbox" && (
              <th>
                <AllCheckerCheckbox className="cursor-pointer" onChange={(e) => changAll(e)} />
                {/* <CheckItem
                  checkboxAll={checkboxAllHeader}
                  headerCheckbox={true}
                  callBack={(callBack) => {
                      handleCheckAll()
                  }}
                /> */}
              </th>
            )}
            {columns.length !== 0 &&
              columns.map((data, index) => {
                return <th key={index}>{data.title}</th>;
              })}
          </tr>

          {dataSource.length !== 0 &&
            columns.length !== 0 &&
            dataSource.map((dataSource, index) => {
              let styleBackground = functionStyleTableRow
                ? functionStyleTableRow(dataSource)
                : "#FFF";
              return (
                <tr
                  className="tr-table-components"
                  key={index}
                  style={{
                    background: styleBackground ? styleBackground : "#FFF",
                  }}
                >
                  {rowSelection !== undefined &&
                    rowSelection.type === "checkbox" && (
                      <td className={returnClass(0, 1)}>
                       <Checkbox className="cursor-pointer" onChange={(e) => changCheckbox(e, dataSource, index)} />
                        {/* <CheckItem
                          checkboxAll={checkboxAllHeader}
                          callBack={(callBack) =>
                            selectCheckbox(callBack, dataSource, index)
                          }
                        /> */}
                      </td>
                    )}

                  {columns.map((dataColumns, index_columns) => {
                    if (dataColumns.render) {
                      if (dataColumns.dataIndex !== undefined) {
                        return (
                          <td
                            className={returnClass(index_columns, columns)}
                            key={index_columns}
                          >
                            {dataColumns.render(
                              dataSource[dataColumns.dataIndex]
                            )}
                          </td>
                        );
                      } else {
                        return (
                          <td
                            className={returnClass(index_columns, columns)}
                            key={index_columns}
                          >
                            {dataColumns.render(dataSource)}
                          </td>
                        );
                      }
                    } else {
                      return (
                        <td
                          className={returnClass(index_columns, columns)}
                          key={index_columns}
                        >
                          {dataSource[dataColumns.dataIndex]
                            ? dataSource[dataColumns.dataIndex]
                            : null}
                          {dataColumns.lineRight === true && (
                            <div className="div-line-right-by-nile" />
                          )}
                        </td>
                      );
                    }
                  })}
                </tr>
              );
            })}
        </tbody>
      </table>
      </CheckboxGroup>
    </div>
  );
}


// import React, { useState, useEffect } from "react";
// import CheckItem from "../components/CheckItem";

// export default function TableLogComponents({
//   columns,
//   dataSource,
//   functionStyleTableRow,
//   rowSelection,
// }) {
//   const [checkboxArray, setCheckboxArray] = useState([]);
//   const [checkboxAll, setCheckboxAll] = useState(false);

//   function handleCheckAll() {
//     setCheckboxAll(!checkboxAll)
//   }

//   function selectCheckbox(callBack, dataSource, index) {
//     let dataCheckboxAll = checkboxArray;
//     dataCheckboxAll.sort(compareFirst);
//     if (callBack === true) {
//       dataCheckboxAll.push({
//         ...dataSource,
//         indexDataCheckboxAll: index,
//       });
//     } else {
//       var indexRemoveData = dataCheckboxAll.findIndex(
//         (std) => std.indexDataCheckboxAll === index
//       );
//       dataCheckboxAll.splice(indexRemoveData, 1);
//     }

//     dataCheckboxAll.sort(compareFirst);
//     setCheckboxArray(dataCheckboxAll);
//     rowSelection.onChange(dataCheckboxAll);
//   }

//   function returnClass(index_columns, allIndex) {
//     if (index_columns === 0) return "td-first-table";
//     else if (index_columns === allIndex.length - 1) return "td-last-table";
//     else return null;
//   }

//   function compareFirst(a, b) {
//     if (a.indexDataCheckboxAll > b.indexDataCheckboxAll) {
//       return 1;
//     }
//     if (a.indexDataCheckboxAll < b.indexDataCheckboxAll) {
//       return -1;
//     }
//     return 0;
//   }

//   return (
//     <div className="div-table-components-by-nile">
//       <table className="table-log-all-components" style={{ overflowX: "auto" }}>
//         <tbody>
//           <tr>
//             {rowSelection !== undefined && rowSelection.type === "checkbox" && (
//               <th>
//                 <CheckItem
//                   callBack={(callBack) => {
//                     handleCheckAll()
//                     console.log(callBack);
//                   }}
//                 />
//               </th>
//             )}
//             {columns.length !== 0 &&
//               columns.map((data, index) => {
//                 return <th key={index}>{data.title}</th>;
//               })}
//           </tr>

//           {dataSource.length !== 0 &&
//             columns.length !== 0 &&
//             dataSource.map((dataSource, index) => {
//               let styleBackground = functionStyleTableRow
//                 ? functionStyleTableRow(dataSource)
//                 : "#FFF";
//               // {
//               //   columns.map( (checkStyleTR) => {
//               //     if(checkStyleTR.functionStyleTR){
//               //       styleBackground = checkStyleTR.functionStyleTR(dataSource)
//               //     }
//               //   } )
//               // }
//               return (
//                 <tr
//                   className="tr-table-components"
//                   key={index}
//                   style={{
//                     background: styleBackground ? styleBackground : "#FFF",
//                   }}
//                 >
//                   {rowSelection !== undefined &&
//                     rowSelection.type === "checkbox" && (
//                       <td className={returnClass(0, 1)}>
//                         <CheckItem
//                           checkboxAll={checkboxAll}
//                           callBack={(callBack) =>
//                             selectCheckbox(callBack, dataSource, index)
//                           }
//                         />
//                       </td>
//                     )}

//                   {columns.map((dataColumns, index_columns) => {
//                     if (dataColumns.render) {
//                       if (dataColumns.dataIndex !== undefined) {
//                         return (
//                           <td
//                             className={returnClass(index_columns, columns)}
//                             key={index_columns}
//                           >
//                             {dataColumns.render(
//                               dataSource[dataColumns.dataIndex]
//                             )}
//                           </td>
//                         );
//                       } else {
//                         return (
//                           <td
//                             className={returnClass(index_columns, columns)}
//                             key={index_columns}
//                           >
//                             {dataColumns.render(dataSource)}
//                           </td>
//                         );
//                       }
//                     } else {
//                       return (
//                         <td
//                           className={returnClass(index_columns, columns)}
//                           key={index_columns}
//                         >
//                           {dataSource[dataColumns.dataIndex]
//                             ? dataSource[dataColumns.dataIndex]
//                             : null}
//                           {dataColumns.lineRight === true && (
//                             <div className="div-line-right-by-nile" />
//                           )}
//                         </td>
//                       );
//                     }
//                   })}
//                 </tr>
//               );
//             })}
//         </tbody>
//       </table>
//     </div>
//   );
// }
